import { render, staticRenderFns } from "./ro_sidebar.vue?vue&type=template&id=039ed612&"
import script from "./ro_sidebar.vue?vue&type=script&lang=js&"
export * from "./ro_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./ro_sidebar.vue?vue&type=style&index=0&id=039ed612&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports